import { useEffect, useMemo } from 'react';
import { NestedIdValue } from '../../../../../../../../features/multi-select/use-multi-select';
import { useLang } from '../../../../../../../../hooks/use-lang';
import { useBranchesStore } from '../../../../../../../../store/use-branch-store';
import { useQrStore } from '../../../../../../../../store/use-qr-store';
import { useQrTemplatesStore } from '../../../../../../../../store/use-qr-templates-store';
import { qrTemplates } from '../helpers';

export const usePrintSettings = () => {
  const { t, getLocale } = useLang();

  const { fetchBranches, place, isLoadingFetch: isLoadingBranch } = useBranchesStore();
  const {
    fetchTemplates,
    templates: loadedTemplates,
    isLoadingFetch: isLoadingFetchTemplates,
  } = useQrTemplatesStore();

  const { fetchAllQrs, allQrs, isLoadingFetch: isLoadingFetchQrList } = useQrStore();

  useEffect(() => {
    fetchAllQrs();
    fetchTemplates({ is_by_company: true });
    fetchBranches({ n: 1000, since_id: 0, customCache: true });
  }, []);

  const templates = [
    ...qrTemplates,
    ...(loadedTemplates?.map((item) => ({ id: item.id, value: item.name })) || []),
  ];

  const groupedQrCodesByBranch = useMemo(() => {
    const result: NestedIdValue[] = [];
    allQrs?.forEach((qr) => {
      const branch = place?.find((item) => item.id === qr.place_id);

      if (!branch) {
        return;
      }
      const isExist = result.some((item) => item.id === String(branch.id));
      const addableQr = { id: qr.id, value: getLocale(qr.name) };
      if (isExist) {
        const index = result.findIndex((item) => item.id === String(branch.id));
        result[index].children?.push(addableQr);
      } else {
        result.push({
          id: String(branch.id),
          value: getLocale(branch.name),
          children: [addableQr],
        });
      }
    });

    return result;
  }, [getLocale, place, allQrs]);

  return {
    t,
    templates,
    isLoading: isLoadingFetchTemplates || isLoadingFetchQrList || isLoadingBranch,
    groupedQrCodesByBranch,
  };
};
